import {useEffect, useState} from "react";

import {EquipmentPage} from "../EquipmentPage/EquipmentPage.jsx";
import {MaterialPage} from "../MaterialPage/MaterialPage.jsx";
import api from "../../api.js";
import Auth from "../../Auth.js";
import {Menu} from "@/layouts/Menu/Menu.jsx";
import {properties} from "@/properties.js";
import {AddImageModal} from "@/components/custom/AddImageModal/AddImageModal.jsx";
import {useNavigate, useSearchParams} from "react-router-dom";

import styles from "./FullPage.module.css";
import {App as AntdApp} from "antd";

export const FullPage = () => {
	const {message} = AntdApp.useApp();

	const [data, setData] = useState({
		item: {
			type: "",
			operator: "",
			material: "",
			part_number: "",
		},
		images: /** @type {{id: string, image: string, active: number}[]} */ ([]),
		documentsList: /** @type {any[]} */ ([]),
	});

	const [ui, setUi] = useState({
		showModal: false,
		image: "",
		canEditImages: false,
	});

	const [searchParams] = useSearchParams();

	const operatorFromUrl = searchParams.get("operator") || "";
	const materialFromUrl = searchParams.get("material") || "";

	async function getDocumentsList(operator, material) {
		try {
			const json = await api.post(`/documents/get`, {operator, material});
			const documentsListData = json.data;

			setData(prev => ({
				...prev,
				documentsList: documentsListData,
			}));
		} catch (error) {
			console.log(error);
		}
	}

    async function loadGallery(item) {
        try {
            const response = await api.post(`/images`, {
                material: item.material,
                type: "img",
                operator: item.operator,
                part_number: item.part_number || "",
            });
            const ids = response.data || [];

            const imagePromises = ids.map(async id => {
                const config = {...Auth.headers(), responseType: "blob"};
                const res = await api.post(`/image/id`, {_id: id}, config);

                const header = res.headers["content-disposition"];
                const filenameMatch = /filename=(.*)/.exec(header);
                const isActive = filenameMatch ? filenameMatch[1].replace(/"/g, "") === "True" : false;

                return {
                    id,
                    image: URL.createObjectURL(res.data),
                    active: isActive ? 1 : 0,
                };
            });

            const fullGallery = await Promise.all(imagePromises);

			setData(prev => ({...prev, images: fullGallery}));
		} catch (error) {
			setData(prev => ({...prev, images: []}));
			console.error(error);
		}
	}
	function onModalClose() {
		setUi(prev => ({
			...prev,
			showModal: false,
			image: "",
		}));
		loadGallery(data.item);
	}

	function updateItem(part_number) {
		setData(prev => {
			if (part_number === prev.item.part_number) return prev;
			return {
				...prev,
				item: {...prev.item, part_number},
			};
		});
	}

	function openImageModal() {
		setUi(prev => ({...prev, showModal: true}));
	}

	useEffect(() => {
		api.get(`/validate_permission?permission=admin`, {omitGlobalError: true})
			.then(() => setUi(prev => ({...prev, canEditImages: true})))
			.catch(() => {
				api.get(`/validate_permission?permission=superadmin`, {omitGlobalError: true})
					.then(() => setUi(prev => ({...prev, canEditImages: true})))
					.catch(() => {});
			});
	}, []);

	useEffect(() => {
		let url = properties.apiUrl;
		if (sessionStorage.getItem("item_url") && sessionStorage.getItem("item_url") !== null) {
			url = sessionStorage.getItem("item_url");
		} else if (localStorage.getItem("item_url") && localStorage.getItem("item_url") !== null) {
			url = localStorage.getItem("item_url");
			sessionStorage.setItem("item_url", url);
		}

		api.post(`/item/type-info?operator=${encodeURIComponent(operatorFromUrl)}&material=${materialFromUrl}`, {url})
			.then(json => {
				setData(prev => ({
					...prev,
					item: {
						...prev.item,
						operator: operatorFromUrl,
						material: materialFromUrl,
						part_number: json.data.part_number,
						type: json.data.type || "material",
					},
				}));
			})
			.catch(error => {
				console.log(error);
				setData(prev => ({
					...prev,
					item: {
						...prev.item,
						operator: operatorFromUrl,
						material: materialFromUrl,
						part_number: "",
						type: "material",
					},
				}));
			});
	}, [operatorFromUrl, materialFromUrl]);

	useEffect(() => {
		if (data.item.operator && data.item.material) {
			loadGallery(data.item);
			getDocumentsList(data.item.operator, data.item.material);
		}
	}, [data.item.operator, data.item.material]);

	return (
		<div data-testid="full-page-container">
			<Menu />
			<main className={styles.mainContent}>
				{data.item.type === "material" && (
					<MaterialPage
						documentsList={data.documentsList}
						image={ui.image}
						onItemUpdate={updateItem}
						show={ui.canEditImages}
						getDocumentsList={getDocumentsList}
						images={data.images}
						openImageModal={openImageModal}
					/>
				)}

				{data.item.type === "equipment" && (
					<EquipmentPage
						onItemUpdate={updateItem}
						getDocumentsList={getDocumentsList}
						documentsList={data.documentsList}
						image={ui.image}
						show={ui.canEditImages}
						images={data.images}
						openImageModal={openImageModal}
					/>
				)}
			</main>
			{ui.showModal && ui.canEditImages && (
				<AddImageModal show={ui.showModal} onClose={onModalClose} item={data.item} />
			)}
		</div>
	);
};
